import Cookies from "universal-cookie";

// Lista de títulos anulados no Ampli Obras (change client-title-annulments, D2). Mesmo padrão
// de `outlets/backoffice/titleAnnulmentsApi.js` (fetch + Bearer do cookie, `{ ok, status, body }`,
// nunca lança), só que na API principal (SERVER_URL) e escopado pela obra aberta:
//   GET  /project/{id}/title-annulments
//   POST /project/{id}/title-annulments/preview
//   POST /project/{id}/title-annulments
//   POST /project/{id}/title-annulments/{annulmentId}/revoke

const cookies = new Cookies();
const enc = (value) => encodeURIComponent(String(value));

const resolveUrl = (path) => {
  const base = process.env.SERVER_URL || "";
  if (!base) return null;
  try {
    const parsed = new URL(base);
    if (!["http:", "https:"].includes(parsed.protocol) || parsed.username || parsed.password) return null;
    const basePath = parsed.pathname.replace(/\/+$/, "");
    const url = new URL(`${basePath}/${path}`, `${parsed.origin}/`);
    return url.origin === parsed.origin ? url : null;
  } catch {
    return null;
  }
};

const request = async (path, { method = "GET", body } = {}) => {
  const url = resolveUrl(path);
  if (!url) return { ok: false, status: 0, body: { message: "Servidor não configurado." } };
  const { token } = cookies.get("userId") || {};
  if (typeof token !== "string" || !token) {
    return { ok: false, status: 401, body: { message: "Faça login novamente." } };
  }
  try {
    const response = await fetch(url.toString(), {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
      },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json().catch(() => null);
    return { ok: response.ok, status: response.status, body: data };
  } catch {
    return { ok: false, status: 0, body: { message: "Não foi possível comunicar com o servidor." } };
  }
};

const base = (projectId) => `project/${enc(projectId)}/title-annulments`;

export const fetchProjectTitleAnnulments = (projectId) => request(base(projectId));

export const previewProjectTitleAnnulments = (projectId, body) => (
  request(`${base(projectId)}/preview`, { method: "POST", body })
);

export const createProjectTitleAnnulments = (projectId, body) => (
  request(base(projectId), { method: "POST", body })
);

export const revokeProjectTitleAnnulment = (projectId, annulmentId, body) => (
  request(`${base(projectId)}/${enc(annulmentId)}/revoke`, { method: "POST", body })
);

export const projectTitleAnnulmentsApi = {
  list: fetchProjectTitleAnnulments,
  preview: previewProjectTitleAnnulments,
  create: createProjectTitleAnnulments,
  revoke: revokeProjectTitleAnnulment,
};
